import { paymentIframePostAndListen } from 'Utils/Payment';
import { logger } from 'Utils/Logger';
import evergentCodeDetails from 'Config/EvergentCodeDetails.json';
import {
  addSubscriptionResponse,
  changeSubscriptionResponse,
  getAddSubscriptionRequest,
  getChangeSubscriptionRequest,
} from 'Utils/Subscriptions';

// payment iframe events, suffix with REQUEST and RESPONSE
const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION';
const CHANGE_SERVICE = 'CHANGE_SERVICE';
const UPDATE_PAYMENT_INFO = 'UPDATE_PAYMENT_INFO';

export const getErrorMessageFromCode = (code) =>
  code ? evergentCodeDetails[code] || evergentCodeDetails.defaultErrorMessage : null;

/* iframe post messages - start */
// new card iframe events, add and change subscription
export const cardPaymentAddSubscription = (data) => {
  const payload = getAddSubscriptionRequest(data);
  logger.apiRequest('add subscription iframe', payload);
  return paymentIframePostAndListen(ADD_SUBSCRIPTION, payload).then(addSubscriptionResponse);
};

export const cardPaymentChangeSubscription = (data) => {
  const payload = getChangeSubscriptionRequest(data);
  logger.apiRequest('change service iframe', payload);
  return paymentIframePostAndListen(CHANGE_SERVICE, payload).then(changeSubscriptionResponse);
};

// edit card payment on profile page.
const updateCardPaymentMethod = () => paymentIframePostAndListen(UPDATE_PAYMENT_INFO, {});
/* iframe post messages - end */

// API
export const updateCardPayment = async () => {
  try {
    logger.apiRequest('update payment iframe', null);
    const response = await updateCardPaymentMethod();

    const {
      UpdatePaymentInfoResponseMessage: { responseCode = '0', failureMessage: { errorCode } = {} },
    } = response;

    if (!responseCode) {
      throw new Error('Invalid API response: updateCardPayment');
    }
    logger.apiResponse('update payment iframe', response);
    const isSuccess = responseCode === '1';
    const errorMessage = getErrorMessageFromCode(errorCode);
    return { isSuccess, errorMessage };
  } catch (error) {
    logger.apiError('update payment iframe', null, error);
    return {
      errorCode: 'EV_API_ERROR',
      errorMessage: error.message,
      isSuccess: false,
    };
  }
};
